import store from '../../admin/store'
import { ACTUALITY_SET_STATUS } from '../../admin/reducers/app'

/**
 * Download all news and save to store
 *
 * @returns {Promise<void>|Promise<void>}
 */
export const fetchNews = (reset = false, limit = 20, filter = null) => {
    const appState = store.getState().app
    const news = appState?.news
    const cursor = reset ? 0 : news?.cursor
    const config = window.APP_CONFIG
    const system = config.REACT_APP_SYSTEM

    const includes = [
        'mainPhoto',
        'categories',
        'tags',
        'owner',
    ].join(',')

    const urlFilter = filter?.replace('take=next', '') || ''
    let url = `${config.REACT_APP_API_URL}api/news?include=${includes}&limit=${limit}&cursor=${cursor}&system=${system}&${urlFilter}`

    if (reset) {
        store.dispatch({
            type: 'NEWS_FETCHED',
            news: [],
            reset,
        })
    }

    store.dispatch({
        type: 'TOGGLE_BUSY_SECTION',
        section: 'news',
    })

    return window.axios.get(url)
        .then(({ data }) => {
            if (data && data.data) {
                store.dispatch({
                    type: 'NEWS_FETCHED',
                    news: data.data,
                    reset,
                })
                store.dispatch({
                    type: 'SET_CURSOR',
                    entity: 'news',
                    value: data.meta.cursor.next ?? 0,
                })
            } else {
                store.dispatch({
                    type: 'SET_CURSOR',
                    entity: 'news',
                    value: 0,
                })
            }

            store.dispatch({
                type: 'TOGGLE_BUSY_SECTION',
                section: 'news',
            })
        })
}

export const setElement = (entity, value, type = 'SET_CURSOR') => (
    new Promise(resolve => {
        store.dispatch({
            type,
            entity,
            value,
        })

        resolve()
    })
)

/**
 * Download all news without chosen news category and save to store
 *
 * @returns {Promise<void>|Promise<void>}
 */
export const fetchNotFilteredNews = (reset = false, limit = 20, filter = null) => {
    const appState = store.getState().app
    const notFilteredNews = appState?.notFilteredNews
    const config = window.APP_CONFIG
    const system = config.REACT_APP_SYSTEM
    const cursor = reset ? 0 : notFilteredNews?.cursor

    const includes = [
        'mainPhoto',
        'categories',
        'tags',
        'owner',
    ].join(',')

    if (reset) {
        store.dispatch({
            type: 'NOT_FILTERED_NEWS_FETCHED',
            notFilteredNews: [],
            reset,
        })
    }

    store.dispatch({
        type: 'TOGGLE_BUSY_SECTION',
        section: 'notFilteredNews',
    })


    if (filter) {
        const chosenCategoryId = filter?.replace('category=', '')
        const urlWithoutCategory = `${config.REACT_APP_API_URL}api/news?include=${includes}&limit=${limit}&cursor=${cursor}&system=${system}&notCategory=${chosenCategoryId}`
        window.axios.get(urlWithoutCategory)
            .then(({ data }) => {
                if (data && data.data) {
                    store.dispatch({
                        type: 'NOT_FILTERED_NEWS_FETCHED',
                        notFilteredNews: data.data,
                        reset,
                    })
                    store.dispatch({
                        type: 'SET_CURSOR',
                        entity: 'notFilteredNews',
                        value: data.meta.cursor.next ?? 0,
                    })
                } else {
                    store.dispatch({
                        type: 'SET_CURSOR',
                        entity: 'notFilteredNews',
                        value: null,
                    })
                }
            })
        store.dispatch({
            type: 'TOGGLE_BUSY_SECTION',
            section: 'notFilteredNews',
        })

    }
}

/**
 * Download data for current actuality and save to store
 *
 * @returns {Promise<void>|Promise<void>}
 */
export const fetchNewsDetail = () => {
    const appState = store.getState().app
    const news = appState?.news
    const busy = store.getState().ui.busySections.news
    const actualityId = news.actualityId
    const config = window.APP_CONFIG

    if (!actualityId || busy) {
        return Promise.resolve()
    }

    const url = `${config.REACT_APP_API_URL}api/news/${actualityId}?include=mainPhoto,photo,categories,tags,owner&optFields=full`

    store.dispatch({
        type: 'TOGGLE_BUSY_SECTION',
        section: 'news',
    })

    store.dispatch({
        type: ACTUALITY_SET_STATUS,
        status: null,
    })

    return window.axios.get(url)
        .then(({ data }) => {
            if (data?.data) {
                store.dispatch({
                    type: 'ACTUALITY_FETCHED',
                    fullActuality: data?.data,
                })
                store.dispatch({
                    type: ACTUALITY_SET_STATUS,
                    status: 200,
                })
            } else {
                store.dispatch({
                    type: ACTUALITY_SET_STATUS,
                    status: 403,
                })
            }
        })
        .catch(error => {
            if (error?.status) {
                store.dispatch({
                    type: ACTUALITY_SET_STATUS,
                    status: error?.status,
                })
            }
        })
        .finally(() => {
            store.dispatch({
                type: 'TOGGLE_BUSY_SECTION',
                section: 'news',
            })
        })
}



/**
 * Download all available news categories and save to store
 *
 * @returns {Promise<void>|Promise<void>}
 */
export const fetchNewsCategories = () => {
    const url = `${window.APP_CONFIG.REACT_APP_API_URL}api/news/categories`

    return window.axios.get(url)
        .then(({ data }) => {
            if (data) {
                store.dispatch({
                    type: 'NEWS_CATEGORIES_FETCHED',
                    newsCategories: data,
                })
            }
        })
}



/**
 * Download all available news tags and save to store
 *
 * @returns {Promise<void>|Promise<void>}
 */
export const fetchNewsTags = () => {
    const url = `${window.APP_CONFIG.REACT_APP_API_URL}api/news/tags`

    return window.axios.get(url)
        .then(({ data }) => {
            if (data) {
                store.dispatch({
                    type: 'NEWS_TAGS_FETCHED',
                    newsTags: data,
                })
            }
        })
}
